//  Copyright (c) 2019-2023 Cigent Technology Inc. All Rights Reserved.
import { Component, ViewChild } from '@angular/core';
import {UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators} from '@angular/forms';
import {MatDialogRef} from '@angular/material/dialog';
import { MatTooltip } from '@angular/material/tooltip';

export interface IUploadKeyDialogResult {
  file: File;
  name?: string;
  password?: string;
  expirationDate?: Date;
}

@Component({
    selector: 'app-upload-key-dialog',
    templateUrl: './upload-key-dialog.component.html',
    styleUrls: ['./upload-key-dialog.component.scss'],
    standalone: false
})
export class UploadKeyDialogComponent {
  @ViewChild('tooltip') tooltip: MatTooltip;
  fg: UntypedFormGroup;
  file: File;
  expirationDisabled = true;
  displayPasswordWarning = false;
  capsOn: boolean = false;
  passwordInputIsFocused = false;


  constructor(private readonly formBuilder: UntypedFormBuilder,
              private readonly dialogRef: MatDialogRef<UploadKeyDialogComponent>) {
    this.fg = formBuilder.group({
      file: new UntypedFormControl( '', Validators.required),
      name: new UntypedFormControl({value: '', disabled: true}, Validators.required),
      expirationDate: new UntypedFormControl({value: new Date(), disabled: true}, Validators.required),
      password: new UntypedFormControl({value: '', disabled: true}),
    });
  }

  onClickOK() {
    const result: IUploadKeyDialogResult = {
      name: this.fg.value.name || '',
      password: this.fg.value.password || '',
      file: this.file,
      expirationDate: this.fg.value.expirationDate,
    }
    this.dialogRef.close(result);
  }

  setFile(event) {
    const files: File[] = event.target.files;
    if (files.length === 1) {
      this.file = files[0];

      if (this.file.name.endsWith(".k3y")) {
        this.fg.controls['password'].enable();
        this.fg.controls['name'].disable();
        this.displayPasswordWarning = true;
      } else {
        this.fg.controls['name'].enable();
        this.fg.controls['password'].disable();
        this.displayPasswordWarning = false;
      }

    }
  }

  onClickCancel() {
    this.dialogRef.close();
  }

  expirationToggle(event) {
    const formControl = this.fg.controls['expirationDate'];
    if (event.checked) {
      formControl.enable();
    } else {
      formControl.disable();
    }
  }

  onCapsLockChanged(event: boolean) {
    this.capsOn = event && this.passwordInputIsFocused;
  }

  passwordFocus() {
    this.passwordInputIsFocused = true;
  }

  passwordBlur() {
    this.passwordInputIsFocused = false;
  }

}
